import { useParams } from "react-router-dom";
import Divider from "../../components/common/aesthetics/Divider.jsx";
import AppBreadcrumbs from "../../components/common/breadcrumbs/AppBreadcrumbs.jsx";
import FormProductEdit from "../../components/common/form/FormProductEdit.jsx";
import Page from "../../components/layout/Page.jsx";
import useProduct from "../../hooks/useProduct.jsx";

const ProductEdit = () => {
  const { productId } = useParams();
  const { data, loading, error } = useProduct(productId);

  if (loading) {
    return (
      <Page>
        <div>Cargando elemento</div>
      </Page>
    );
  }
  if (error) {
    return (
      <Page>
        <div>Error: {error.message}</div>
      </Page>
    );
  }
  if (!data) {
    return (
      <Page>
        <div>No se han encontrado ningun elemento</div>
      </Page>
    );
  }

  const bcSteps = [
    { to: "/products", label: "Productos" },
  ];

  return (
    <Page>
      <AppBreadcrumbs steps={bcSteps} currentPage="Editar" />
      <div>
        <h1 className="font-bold text-2xl">Editar Producto</h1>
        <span>Cambie la información del producto que quiera modificar</span>
      </div>
      <Divider className="mb-10" />
      <FormProductEdit product={data} />
    </Page>
  );
};

export default ProductEdit;
